module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rail-field-widget"
  }, [_c('div', [_c('a', {
    staticClass: "doc-link scrollAnchor",
    attrs: {
      "href": "#mecanisme",
      "target": _vm._blank
    },
    domProps: {
      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.railType.compareRailLink)
    }
  })]), _vm._l((_vm.adaptedRailTypes()), function(adaptedRailType) {
    return _c('div', [_c('div', {
      staticClass: "rail-type-title"
    }, [_c('div', {
      staticClass: "rail-type-title-part"
    }, [_c('span', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(adaptedRailType.opt.label)
      }
    }), (adaptedRailType.subTitle) ? _c('span', {
      staticClass: "sub-title",
      domProps: {
        "textContent": _vm._s(adaptedRailType.subTitle)
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "rail-type-title-part",
      domProps: {
        "textContent": _vm._s(adaptedRailType.priceIndicator)
      }
    }), (adaptedRailType.colorSumary) ? _c('div', {
      staticClass: "rail-type-title-part"
    }, [(adaptedRailType.colorSumary) ? _c('span', {
      staticClass: "color-summary",
      domProps: {
        "textContent": _vm._s(adaptedRailType.colorSumary)
      }
    }) : _vm._e()]) : _vm._e()]), _c('div', _vm._l((adaptedRailType.relatedColorOpt), function(railColor) {
      return _c('div', {
        staticClass: "color-picto-hexa-container"
      }, [_c('label', {
        staticClass: "color-picto-hexa",
        class: {
          'selected': (_vm.selected === railColor.colorOptKey)
        },
        style: ({
          'background-color': railColor.pictureColor,
          'border-color': (_vm.selected === railColor.colorOptKey) ? null : railColor.pictureBorderColor
        }),
        attrs: {
          "for": railColor.colorOptKey
        }
      }), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selected),
          expression: "selected"
        }],
        attrs: {
          "type": "radio",
          "id": railColor.colorOptKey,
          "name": 'railFieldWidget'
        },
        domProps: {
          "value": railColor.colorOptKey,
          "checked": _vm._q(_vm.selected, railColor.colorOptKey)
        },
        on: {
          "change": function($event) {
            _vm.selected = railColor.colorOptKey
          }
        }
      })])
    }))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d1c793a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/abTest/RailFieldWidget.vue
// module id = 369
// module chunks = 1